import { Dispatch, FC, SetStateAction } from "react";
import { CattleFeed } from "../../../../models/Intervention/CattleIntervention";
import { useIntl } from "../../../../../../_metronic/i18n/customUseIntl";
import { useFormContext } from "react-hook-form";
import { DairyIntervention } from "../../../../models/Intervention";
import { enumToOptionsArrayWithTranslatedStrings } from "../../../../utils/obj-utils";
import { FeedStatus } from "../../../../../../graphql/generated/blonk/cattle";
import { DsmGrid } from "@dsm-dcs/design-system-react";
import { CSSClassesList } from "../../../../helpers/helperTypes";
import { processAndStageStylesV2 } from "../../../../../../_metronic/layout";
import { FormType } from "../../common";
import RowSelectWithMetricsV2 from "../../../../../modules/Farms/Intervention/RowSelectWithMetricsV2";
import EditModeButtons from "../../../helpers/EditModeButtons";
import ReactHookDsmSelect from "../../../../../modules/Helpers/ReactHookDsmSelect2";

interface DairyV2FeedDietCharacterisationDialogProp {
  formType: FormType,
  fieldItemPrefix: string;
  currentStageData: CattleFeed;
  originalDietCharacterization: string | undefined;
  isDietEdit: boolean;
  setIsDietEdit: Dispatch<SetStateAction<boolean>>;
  resetEdit: () => void;
}

const DairyV2FeedDietCharacterisationDialog: FC<DairyV2FeedDietCharacterisationDialogProp> = ({
  formType,
  fieldItemPrefix,
  currentStageData,
  originalDietCharacterization = "",
  isDietEdit,
  setIsDietEdit,
  resetEdit,
}) => {
  const intl = useIntl();
  const classes = processAndStageStylesV2() as CSSClassesList;
  const fc = useFormContext<DairyIntervention>();
  const dietCharacterisationOptions = () => enumToOptionsArrayWithTranslatedStrings(
    FeedStatus, intl, 'SUSTELL.STAGE.DAIRY.FEED');

  return (
    <DsmGrid className={classes.dsmGridOneColumnNoGap}>
      {!isDietEdit ? (
        <>
          {(!!fc.getValues(`${fieldItemPrefix}.dietCharacterisation`)
            && fc.getValues(`${fieldItemPrefix}.dietCharacterisation`) !== originalDietCharacterization) ? (
            <RowSelectWithMetricsV2
              name={`${fieldItemPrefix}.dietCharacterisation`}
              label={`${intl.formatMessage({ id: 'SUSTELL.STAGE.DAIRY.FEED.DIET_CHARACTERISATION' })}`}
              tooltip={intl.formatMessage({ id: 'SUSTELL.STAGE.DAIRY.FEED.CONTINUOUS_GROWING.DIET_CHARACTERISATION.TOOLTIP' })}
              options={dietCharacterisationOptions()}
              baseline={currentStageData.dietCharacterisation}
              disabled
            />
          ) : (
            <ReactHookDsmSelect
              name={`${fieldItemPrefix}.originalDietCharacterisation`}
              label={`${intl.formatMessage({ id: 'SUSTELL.STAGE.DAIRY.FEED.DIET_CHARACTERISATION' })}`}
              tooltip={intl.formatMessage({ id: 'SUSTELL.STAGE.DAIRY.FEED.CONTINUOUS_GROWING.DIET_CHARACTERISATION.TOOLTIP' })}
              options={dietCharacterisationOptions()}
              defaultValue={currentStageData.dietCharacterisation}
              disabled
            />
          )}
        </>
      ) : (
        <RowSelectWithMetricsV2
          name={`${fieldItemPrefix}.dietCharacterisation`}
          label={`${intl.formatMessage({ id: 'SUSTELL.STAGE.DAIRY.FEED.DIET_CHARACTERISATION' })}`}
          tooltip={intl.formatMessage({ id: 'SUSTELL.STAGE.DAIRY.FEED.CONTINUOUS_GROWING.DIET_CHARACTERISATION.TOOLTIP' })}
          options={dietCharacterisationOptions()}
          adornment=" "
          baseline={currentStageData.dietCharacterisation}
          disabled={false}
          useStyle={false}
        />
      )}

      {formType !== FormType.View &&
        <EditModeButtons
          isEditing={isDietEdit}
          onEdit={() => setIsDietEdit(true)}
          onCancel={resetEdit}
        />}
    </DsmGrid>
  )
}

export default DairyV2FeedDietCharacterisationDialog;
